'use strict';

var React = require('react');

var SvgTapChipMajor = function SvgTapChipMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 1.5a1.5 1.5 0 0 1 1.5-1.5h12a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5h-4.5v5.5a2.5 2.5 0 0 1-2.5 2.5h-8a2.5 2.5 0 0 1-2.5-2.5v-10.5a4 4 0 0 1 4-4v-.5zm0 2.5a2 2 0 0 0-2 2v7h9v-2h-5.5a1.5 1.5 0 0 1-1.5-1.5v-5.5zm3 2a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1zm-5 10.5v-1.5h9v1.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5z"
  }));
};

exports.SvgTapChipMajor = SvgTapChipMajor;
